module.exports = __webpack_public_path__ + "static/media/panel_history_off.fd2eb369.svg";